import { render, staticRenderFns } from "./UpdateMedicalRecords.vue?vue&type=template&id=52474563"
import script from "./UpdateMedicalRecords.vue?vue&type=script&lang=js"
export * from "./UpdateMedicalRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports